import BottomHeaderSliderImage1 from "./assets/images/HomepageBanner/aus.webp";
import BottomHeaderSliderImage2 from "./assets/images/HomepageBanner/dubai.webp";
import BottomHeaderSliderImage3 from "./assets/images/HomepageBanner/eu.webp";
import BottomHeaderSliderImage4 from "./assets/images/HomepageBanner/ista.webp";
import BottomHeaderSliderImage5 from "./assets/images/HomepageBanner/sou-e-as.webp";
import BottomHeaderSliderImage6 from "./assets/images/HomepageBanner/swiss.webp";
import BottomHeaderSliderImage7 from "./assets/images/HomepageBanner/thai.webp";

export const BannerImgs = [
  BottomHeaderSliderImage1,
  BottomHeaderSliderImage2,
  BottomHeaderSliderImage3,
  BottomHeaderSliderImage4,
  BottomHeaderSliderImage5,
  BottomHeaderSliderImage6,
  BottomHeaderSliderImage7,
];

export const mobileNumberValidator = (value) => {
  let input = value.replace(/\D/g, "");
  if (input.length > 10) {
    input = input.slice(0, 10);
  }
  return input;
};


export const numberValidator = (value = "") => {
  return value.replace(/[^0-9]/g, "");
};

export const indianStatesAndUTs = [
  "Andaman and Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Ladakh",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Puducherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];

/** Indian states/UTs with 2-digit GST state code for dropdowns */
export const INDIAN_STATES_GST = [
  { stateCode: "01", state: "Jammu and Kashmir" },
  { stateCode: "02", state: "Himachal Pradesh" },
  { stateCode: "03", state: "Punjab" },
  { stateCode: "04", state: "Chandigarh" },
  { stateCode: "05", state: "Uttarakhand" },
  { stateCode: "06", state: "Haryana" },
  { stateCode: "07", state: "Delhi" },
  { stateCode: "08", state: "Rajasthan" },
  { stateCode: "09", state: "Uttar Pradesh" },
  { stateCode: "10", state: "Bihar" },
  { stateCode: "11", state: "Sikkim" },
  { stateCode: "12", state: "Arunachal Pradesh" },
  { stateCode: "13", state: "Nagaland" },
  { stateCode: "14", state: "Manipur" },
  { stateCode: "15", state: "Mizoram" },
  { stateCode: "16", state: "Tripura" },
  { stateCode: "17", state: "Meghalaya" },
  { stateCode: "18", state: "Assam" },
  { stateCode: "19", state: "West Bengal" },
  { stateCode: "20", state: "Jharkhand" },
  { stateCode: "21", state: "Odisha" },
  { stateCode: "22", state: "Chhattisgarh" },
  { stateCode: "23", state: "Madhya Pradesh" },
  { stateCode: "24", state: "Gujarat" },
  { stateCode: "26", state: "Dadra and Nagar Haveli and Daman and Diu" },
  { stateCode: "27", state: "Maharashtra" },
  { stateCode: "28", state: "Andhra Pradesh" },
  { stateCode: "29", state: "Karnataka" },
  { stateCode: "30", state: "Goa" },
  { stateCode: "31", state: "Lakshadweep" },
  { stateCode: "32", state: "Kerala" },
  { stateCode: "33", state: "Tamil Nadu" },
  { stateCode: "34", state: "Puducherry" },
  { stateCode: "35", state: "Andaman and Nicobar Islands" },
  { stateCode: "36", state: "Telangana" },
  { stateCode: "37", state: "Ladakh" },
];

export const MealPlans = {
  BI: "Breakfast included",
  AI: "All meals included",
  BLI: "Breakfast & lunch included",
  BDI: "Breakfast & dinner included",
};

// export const roomType = ["Single", "Double ", "Triple", "Other"];

export const roomType = ["Single", "Double ", "Triple"];

export const percentGST = [2.5,5,9, 18];

export const timeSlots = Array.from({ length: 24 }, (_, i) =>
  `${i.toString().padStart(2, "0")}:00`
);

export const extraChargesTypes = ["Liquor/Tobacco", "Laundry", "Others"];

// export const mealInclusionOptions = [
//   { label: "Breakfast included", value: "BI" },
//   { label: "All meals included", value: "AI" },
//   { label: "Breakfast & lunch included", value: "BLI" },
//   { label: "Breakfast & dinner included", value: "BDI" },
// ];

export const mealInclusionOptions = [
  { label: "American Plan", value: "AP" },
  { label: "Modified American Plan", value: "MAP" },
  { label: "Continental Plan", value: "CP" },
  { label: "European Plan", value: "EP" },
];

export const InternalGSTData = [
  {
    state: "Goa",
    tradeName: "UrSmartspoc - A Unit of B H & Company",
    GSTIN: "30ACIPH7450F1ZZ",
    pan: "ACIPH7450F",
    sacCode: "9985",
    address:
      "URSMARTSPOC A UNIT OF B H AND Co., N-66, Phase IV, Verna Industrial Estate Goa 403722",
    stateCode: "30",
  },
  {
    state: "Uttar Pradesh",
    tradeName: "UrSmartspoc - A Unit of B H & Company",
    GSTIN: "09ACIPH7450F1ZK",
    pan: "ACIPH7450F",
    sacCode: "9985",
    address:
      "URSMARTSPOC A UNIT OF B H AND Co., Desk No DW-0015, Alpha 10, Noida, D9 Sector 3, Noida, Gautambuddha Nagar, Uttar Pradesh, 201301",
    stateCode: "09",
  },
  {
    state: "Haryana",
    tradeName: "UrSmartspoc - A Unit of B H & Company",
    GSTIN: "06ACIPH7450F1ZQ",
    pan: "ACIPH7450F",
    sacCode: "9985",
    address:
      "URSMARTSPOC A UNIT OF B H AND Co , 7th Floor, 704, Palm Court, Mehruli, Sector 16, Gurugram, Gurugram, Haryana, 122007",
    stateCode: "06",
  },
  {
    state: "Karnataka",
    tradeName: "UrSmartspoc - A Unit of B H & Company",
    GSTIN: "29ACIPH7450F1ZI",
    pan: "ACIPH7450F",
    sacCode: "9985",
    address:
      "B & H COMPANY, 102 MELROSE APARTMENT, NEAR ST.MICHEAL SCHOOL, KESHWAPUR, HUBLI 580023.",
    stateCode: "29",
  },
  {
    state: "Maharashtra",
    tradeName: "UrSmartspoc - A Unit of B H & Company",
    GSTIN: "27ACIPH7450F1ZM",
    pan: "ACIPH7450F",
    sacCode: "9985",
    address:
      "B & H COMPANY, 3,305 JVM Florencia, Ghodbunder Road, Kasarvadavali, Thane, Maharashtra 400615",
    stateCode: "27",
  },
  {
    state: "Telangana",
    tradeName: "UrSmartspoc - A Unit of B H & Company",
    GSTIN: "36ACIPH7450F1ZN",
    pan: "ACIPH7450F",
    sacCode: "9985",
    address:
      "URSMARTSPOC A UNIT OF B H AND Co, Besides Ohri's Restaurant, 1st Floor, 103 A and B, May Fair Garden, Road Number 12, Banjara Hills, Hyderabad, Hyderabad, Telangana, 500034",
    stateCode: "36",
  },
  {
    state: "Bihar",
    tradeName: "UrSmartspoc - A Unit of B H & Company",
    GSTIN: "10ACIPH7450F1Z1",
    pan: "ACIPH7450F",
    sacCode: "9985",
    address:
      "URSMARTSPOC A UNIT OF B H AND Co , Work Studio co-Working, A/3 PC Colony Kankarbagh, Patna, Bihar- 800020",
    stateCode: "10",
  },
  {
    state: "Gujarat",
    tradeName: "UrSmartspoc - A Unit of B H & Company",
    GSTIN: "24ACIPH7450F1ZS",
    pan: "ACIPH7450F",
    sacCode: "9985",
    address:
      "URSMARTSPOC A UNIT OF B H AND Co., CORPHUB, Desk number; 656-D , A -WING 6TH FLOOR , B.D PATEL HOUSE , NARANPURA, Ahemdabad 380009",
    stateCode: "24",
  },
  {
    state: "Chandigarh",
    tradeName: "UrSmartspoc - A Unit of B H & Company",
    GSTIN: "04ACIPH7450F1ZU",
    pan: "ACIPH7450F",
    sacCode: "9985",
    address:
      "URSMARTSPOC A UNIT OF B H AND Co, WorkYard, Plot No 337, Phase, 2, Industrial Area Phase II, Chandigarh, 160002",
    stateCode: "04",
  },
  {
    state: "Kerala",
    tradeName: "UrSmartspoc - A Unit of B H & Company",
    GSTIN: "32ACIPH7450F1ZV",
    pan: "ACIPH7450F",
    sacCode: "9985",
    address:
      "URSMARTSPOC A UNIT OF B H AND Co  TC24/3088/2, Ushasandya Building, Dotspace Business Center, Kowdiar - Devasom Board Road, Kowdiar, Thiruvananthapuram, Thiruvananthapuram, Kerala, 695003",
    stateCode: "32",
  },
  {
    state: "Himachal Pradesh",
    tradeName: "UrSmartspoc - A Unit of B H & Company",
    GSTIN: "02ACIPH7450F1ZY",
    pan: "ACIPH7450F",
    sacCode: "9985",
    address:
      "URSMARTSPOC A UNIT OF B H AND Co , VPO Rakkar, TEHSIL DHARAMSHALA, Dharamshala, Kangra, Himachal Pradesh, 176057",
    stateCode: "02",
  },
  {
    state: "Tamil Nadu",
    tradeName: "UrSmartspoc - A Unit of B H & Company",
    GSTIN: "33ACIPH7450F1ZT",
    pan: "ACIPH7450F",
    sacCode: "9985",
    address:
      "URSMARTSPOC A UNIT OF B H AND CO, INNOV8 MILLENIA RMZ, MILLENIA BUSINESS PARK, CAMPUS 1A, NO.143, DR.M.G.R. ROAD, (NORTH VEERANAM SALAI), PERUNGUDI, SHOLINGANALLUR, CHENNAI, TAMIL NADU PIN CODE -600096",
    stateCode: "33",
  },
  {
    state: "Jharkhand",
    tradeName: "UrSmartspoc - A Unit of B H & Company",
    GSTIN: "20ACIPH7450F1Z0",
    pan: "ACIPH7450F",
    sacCode: "9985",
    address:
      "URSMARTSPOC A UNIT OF B H AND CO, 9th Floor, Mahavir Tower, Work Studio Coworking, Main Road, JD Corporate, Ranchi, Ranchi, Jharkhand PIN CODE -834001",
    stateCode: "20",
  },
  {
    state: "Rajasthan",
    tradeName: "UrSmartspoc - A Unit of B H & Company",
    GSTIN: "08ACIPH7450F1ZM",
    pan: "ACIPH7450F",
    sacCode: "9985",
    address:
      "URSMARTSPOC A UNIT OF B H AND CO, First Floor, Building No S-7, S-10, Geejgarh Tower, Hawa Sarak, Civil Lines, Jaipur District: Jaipur State: Rajasthan PIN CODE -302006",
    stateCode: "08",
  },
  {
    state: "Madhya Pradesh",
    tradeName: "UrSmartspoc - A Unit of B H & Company",
    GSTIN: "23ACIPH7450F1ZU",
    pan: "ACIPH7450F",
    sacCode: "9985",
    address:
      "URSMARTSPOC A UNIT OF B H AND CO, 4th Floor, Work Studio Coworking, Krishna Business Centre, Near Medanta Super Speciality Hospital, Ratna Lok Colony, Indore, Madhya Pradesh 452011",
    stateCode: "23",
  },
  {
    state: "Odisha",
    tradeName: "UrSmartspoc - A Unit of B H & Company",
    GSTIN: "21ACIPH7450F1ZY",
    pan: "ACIPH7450F",
    sacCode: "9985",
    address:
      "URSMARTSPOC A UNIT OF B H AND CO, Building No./Flat No.: Plot no 316, Name Of Premises/Building: District Center, Road/Street: Behind BPCL, Locality/Sub Locality: Chandra Shekharpur, City/Town/Village: Bhubaneswar, District: Khordha, PIN Code: 751016",
    stateCode: "21",
  },
];
